import { Link } from '@tanstack/react-router';
import { t } from 'i18next';
import { LayoutDashboardIcon } from 'lucide-react';

type TabButtonsProps = {
  page: string;
  type?: 'estate' | 'project';
};

export const TabButtons = ({ page = '', type = 'estate' }: TabButtonsProps) => {
  return (
    <div className="flex w-full max-w-[280px] space-x-2">
      <Link
        search={(prev: string[]) => ({
          ...prev,
          view: 'all',
        })}
        className="flex w-1/2 min-w-10 items-center justify-center gap-[8px] rounded-sm px-2 py-1 text-sm text-text-primary hover:bg-primary/10"
        activeProps={{
          className: 'bg-primary !text-primary-lighter hover:!bg-primary/90',
        }}
        from={
          type === 'estate'
            ? `/estates/$estateId/media/${page}`
            : `/projects/$projectId/media/${page}`
        }
        title={t('allMedia')}
        activeOptions={{
          exact: true,
        }}
      >
        <span className="flex size-4 shrink-0 items-center justify-center rounded-md [&_svg]:size-6 [&_svg]:shrink-0 [&_svg]:text-primary-light">
          <LayoutDashboardIcon />
        </span>
        <span className="hidden 2xl:block">{t('allMedia')}</span>
      </Link>
    </div>
  );
};
